export class ScrollLock
{
  static set( isLocked:boolean )
  {
    let htmlRoot = document.querySelector( "html" );
    htmlRoot.style.overflowY = isLocked ? "hidden" : "initial"; 
  }

  static enable()
  {
    ScrollLock.set( true );
  }

  static disable()
  {
    ScrollLock.set( false );
  }

}